import { useTranslation } from 'react-i18next';

import * as St from '../CustomerDataModal.styles';

interface CustomerDataFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
}

const CustomerDataFooter = ({
  onCancel,
  onSubmit,
}: CustomerDataFooterProps) => {
  const { t } = useTranslation();

  return (
    <>
      <St.FooterButton key="cancel" onClick={onCancel}>
        {t('SAVE.LABEL.CANCEL')}
      </St.FooterButton>
      <St.FooterButton key="submit" onClick={onSubmit}>
        {t('SAVE.TITLE')}
      </St.FooterButton>
    </>
  );
};

export default CustomerDataFooter;
